import { useId } from "react";
import { Stack } from "../../Layout";
import { FormControl, FormHelperText, FormInput, FormInputProps, FormLabel } from "../_partials";

export interface TextFieldProps extends Omit<FormInputProps, "id"> {
    helperText?: string;
    isError?: boolean;
    label: string;
}

export function TextField({
    autocomplete,
    endElement,
    helperText = "",
    inputClassName,
    inputRef,
    isError = false,
    label,
    multiline,
    name,
    onChange,
    placeholder,
    type = "text",
    value,
}: TextFieldProps) {
    const id = useId();
    return (
        <FormControl isError={isError}>
            <Stack gap={0.5}>
                <FormLabel htmlFor={id}>{label}</FormLabel>
                <FormInput
                    autocomplete={autocomplete}
                    endElement={endElement}
                    id={id}
                    inputClassName={inputClassName}
                    inputRef={inputRef}
                    multiline={multiline}
                    name={name}
                    onChange={onChange}
                    placeholder={placeholder}
                    type={type}
                    value={value}
                />
                {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
            </Stack>
        </FormControl>
    );
}
